import { useTheme } from '@emotion/react'
import { Inline } from 'chaoskit/src/components'

const LogoList = (props) => {
  const theme = useTheme()

  return (
    <Inline
      css={{
        justifyContent: 'center',

        svg: {
          height: theme.height.small,

          // Modification to align amazon logo with base text styles
          '&.G__LogoList--amazon': {
            transform: 'translateY(20%)',
          },
        },
      }}
      size="xlarge"
      {...props}
    />
  )
}

export default LogoList
